/**yu
 * Local storage relevant operation implementations
 */
const StorageUtil = {
  clearAll: clearAllStorage,
  set: setStorage,
  clear: clearStorage,
  get: getStorage,
};
export default StorageUtil;

/**
 * Clear all of the local storage data
 */
function clearAllStorage() {
  localStorage.clear();
}

/**
 * Set local storage
 *
 * @param name key to store the object
 * @param obj object to be stored
 */
function setStorage(name: string, obj: any) {
  // 设置token 加入30分钟后过期
  // const expries = new Date().getTime() + 30 * 60 * 1000;
  // const tokenObj = {
  //   obj: obj,
  //   expries: expries
  // };
  localStorage.setItem(name, JSON.stringify(obj));
}

/**
 * Remove local storage
 *
 * @param name key of object to be removed form local storage
 */
function clearStorage(name: string) {
  localStorage.removeItem(name);
}

/**
 * Get an item from local storage, return with an object
 *
 * @param name key of object to be fetched form local storage
 */
function getStorage(name: string | null) {
  if (name === null) {
    return null;
  }
  const item = localStorage.getItem(name);
  if (item === null) {
    return null;
  }
  try {
    return JSON.parse(item);
  } catch (error) {
    console.error('Error parsing JSON from localStorage', error);
    return null;
  }
}
